import React from 'react';
import {
	colorBackgroundLayoutMain,
	colorBorderDividerDefault,
	fontFamilyMonospace,
	borderRadiusInput,
} from '@amzn/awsui-design-tokens/polaris';
import { MarkdownContent } from './MarkdownContent';

interface MarkdownCodeBlockProps {
	content?: string | null;
}

/**
 * Renders markdown content (with escaped whitespace normalized) inside a
 * code-view-like block. The styling is driven entirely by Cloudscape design
 * tokens (background, border, radius, monospace font).
 */
export const MarkdownCodeBlock: React.FC<MarkdownCodeBlockProps> = ({ content }) => (
	<div
		data-testid="markdown-code-block"
		style={{
			backgroundColor: colorBackgroundLayoutMain,
			border: `1px solid ${colorBorderDividerDefault}`,
			borderRadius: borderRadiusInput,
			padding: '8px 12px',
			overflowX: 'auto',
			fontFamily: fontFamilyMonospace,
			fontSize: '13px',
			lineHeight: 1.5,
		}}
	>
		<MarkdownContent content={content} />
	</div>
);

export default MarkdownCodeBlock;
